import React from 'react';
import PropTypes from 'prop-types';

import { useIcewormFocusTrap } from '../../../focus/withFocusTrap';
import styles from '../../testOverview.scss';
import TestComponentIdVerification from '../idverification/TestComponentIdVerification';
import TestComponentRoomScanContainer from '../roomscan/TestComponentRoomScan';
import TestComponentManualIdVerification from '../manualidverification/TestComponentManualIdVerification';
import AudioVideoCheck from '../audioVideoCheck/AudioVideoCheck';
import testComponentPreChecksSelector from '../../../../selectors/testOverview/testComponents/preChecks/TestComponentPreChecksSelector';

const TestComponentPreChecks = (props) => {
    const {
        allShownChecksCompleted,
        hardwareArePreviousChecksComplete,
        readinessCheckComponent,
        showAudioVideoCheck,
        showAutomaticIdVerification,
        showManualIdVerification,
        showRoomScan,
        title,
    } = props;

    useIcewormFocusTrap();
    const getPrecheckSteps = () => {
        return (<React.Fragment>
            { readinessCheckComponent }
            { showAudioVideoCheck &&
                <AudioVideoCheck arePreviousChecksComplete={hardwareArePreviousChecksComplete} />
            }
            { showAutomaticIdVerification && <TestComponentIdVerification /> }
            { showManualIdVerification && <TestComponentManualIdVerification /> }
            { showRoomScan && <TestComponentRoomScanContainer /> }
        </React.Fragment>);
    };

    return (
        <div className={`${styles.childTest} ${styles.preChecks}`}>
            <div className={`${styles.contentWrapper} ${allShownChecksCompleted && styles.contentCompleted}`}>
                <h3>{title}</h3>
                { allShownChecksCompleted
                    ? <div className={styles.completed}>
                        <i className="fa fa-check" aria-hidden />
                    </div>
                    : getPrecheckSteps()
                }
            </div>
        </div>
    );
};

TestComponentPreChecks.propTypes = {
    allShownChecksCompleted: PropTypes.bool.isRequired,
    hardwareArePreviousChecksComplete: PropTypes.bool.isRequired,
    readinessCheckComponent: PropTypes.element,
    showAudioVideoCheck: PropTypes.bool.isRequired,
    showAutomaticIdVerification: PropTypes.bool.isRequired,
    showManualIdVerification: PropTypes.bool.isRequired,
    showRoomScan: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
};

const TestComponentPreChecksWrapper = (props) => {
    const composedProps = testComponentPreChecksSelector.computeProps(props);
    return <TestComponentPreChecks {...props} {...composedProps} />;
};

export default TestComponentPreChecksWrapper;
